<template>
  <div>
    <showroom></showroom>
  </div>
</template>

<script>
import showroom from '@views/appletManagement/showroom'
export default {
  data() {
    return {
      
    };
  },
  components:{
    showroom
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>